import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_melting-moments-1/artifacts/mfe7l5w4_Screenshot%202026-04-14%20at%208.10.43%20PM.png";

const ease = [0.16, 1, 0.3, 1];

const footerLinks = [
  { label: "Collection", id: "product-showcase" },
  { label: "Experience", id: "dual-experience" },
  { label: "Our Story", id: "story-section" },
  { label: "Find Your Pair", id: "find-your-pair" },
];

export default function Footer() {
  const navigate = useNavigate();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      id="footer"
      data-testid="footer"
      className="bg-[#050505] border-t border-[#1F1F1F]"
    >
      <div className="py-20 md:py-28 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
          {/* Logo */}
          <motion.img
            src={LOGO_URL}
            alt="YY Atelier"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease }}
            data-testid="footer-logo"
            className="w-24 md:w-32 h-auto mb-10 mix-blend-lighten"
          />

          {/* Divider */}
          <div className="w-12 h-px bg-[#C6A96B] mb-10" />

          {/* Navigation */}
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 mb-12">
            {footerLinks.map((link) => (
              <button
                key={link.label}
                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => scrollTo(link.id)}
                className="font-body text-xs uppercase tracking-[0.2em] text-[#A3A3A3] hover:text-[#C6A96B] transition-colors duration-500 bg-transparent border-none cursor-pointer"
              >
                {link.label}
              </button>
            ))}
            <button
              data-testid="footer-link-mission-vision"
              onClick={() => navigate("/mission-vision")}
              className="font-body text-xs uppercase tracking-[0.2em] text-[#A3A3A3] hover:text-[#C6A96B] transition-colors duration-500 bg-transparent border-none cursor-pointer"
            >
              Mission & Vision
            </button>
          </div>

          {/* Tagline */}
          <p className="font-heading text-xl md:text-2xl font-light italic text-[#C6A96B]/60 mb-12">
            Two That Melt as One.
          </p>

          {/* Bottom bar */}
          <div className="w-full border-t border-[#1F1F1F] pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-body text-xs text-[#A3A3A3]/50 tracking-wider">
              &copy; {new Date().getFullYear()} YY Atelier. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <span className="font-body text-xs text-[#A3A3A3]/50 tracking-wider hover:text-[#C6A96B] cursor-pointer transition-colors duration-500">
                Privacy
              </span>
              <span className="font-body text-xs text-[#A3A3A3]/50 tracking-wider hover:text-[#C6A96B] cursor-pointer transition-colors duration-500">
                Terms
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
